export default {"src":"/_next/static/media/product-loader.df4a23f2.gif","height":500,"width":1000,"blurWidth":0,"blurHeight":0};